module.exports = __webpack_public_path__ + "img/z-adimg5-3.1a304040.png";